import React from 'react';

import {
  CalendarTodayRounded,
  Chat,
  ConnectWithoutContact,
  CreditCard,
  Description,
  Folder,
  GroupsRounded,
  LocalLibrary,
  Person,
  ReportProblem,
  Work,
} from '@mui/icons-material';

export const dashboardMenus = [
  {
    label: 'Program',
    icon: <LocalLibrary />,
    path: '/program',
  },
  {
    label: 'Transaction',
    icon: <CreditCard />,
    path: '/transactions',
  },
  {
    label: 'Certificate',
    icon: <Description />,
    path: '/e-certificate',
  },
  {
    label: 'Document',
    icon: <Folder />,
    path: '/document',
  },
];

export const alumniMenus = [
  // {
  //   label: 'Talent’s Profile',
  //   icon: <PersonRounded />,
  //   path: '',
  // },

  {
    label: 'Profile',
    icon: <Person />,
    path: '/alumni-profile',
  },
  {
    label: 'Jobs',
    icon: <Work />,
    subItem: [
      {
        label: 'Job Posts',
        path: '/job-posts',
      },
      {
        label: 'My Jobs',
        path: '/job-posts/my-jobs',
      },
      {
        label: 'Post a Job',
        path: '/job-posts/post-jobs',
      },
    ],
  },
  {
    label: 'Tribe',
    icon: <GroupsRounded />,
    path: '/tribe',
  },
  {
    label: 'My Activities',
    icon: <CalendarTodayRounded />,
    path: '/my-activities',
  },
  {
    label: 'Networking',
    icon: <ConnectWithoutContact />,
    path: '/networking',
  },
];

export const helpMenus = [
  {
    label: 'Contact Us',
    icon: <Chat />,
    path: '/contact-us',
  },
];

export const reportMenus = [
  {
    label: 'Report',
    icon: <ReportProblem />,
    path: '/report',
  },
];
